import { jsx as d } from "react/jsx-runtime";
import { useDroppable as F } from "@dnd-kit/core";
import { FORMA_FOLDER_ID_STATIC as f, FORMA_FOLDER_ID_PACKS as O, FORMA_FOLDER_ID_STRICT as a, FORMA_FOLDER_ID_TRASH as i } from "../../../../data/constants.js";
const I = ({ id: o, dropId: e, name: t, type: r, className: R, children: _ }) => {
  const s = !!o && [
    f,
    O,
    a,
    i
  ].includes(o), { setNodeRef: D } = F({
    id: e,
    data: { id: o, name: t, type: r },
    disabled: r !== "folder" || s
  });
  return /* @__PURE__ */ d("div", { className: R, ref: D, children: _ });
};
export {
  I as default
};
